export default __webpack_public_path__ + "static/media/Adult_compressed.42fe4552.png";